// src/config/index.ts

// Determine production fallback URL
const PROD_API_URL = 'https://strymhub.com/api';
const PROD_BACKEND_URL = 'https://strymhub.com';
const DEV_API_URL = 'http://localhost:8080/api';
const DEV_BACKEND_URL = 'http://localhost:8080';

// Check if we're in production mode (Vite sets this automatically during build)
const isProduction = import.meta.env.PROD || import.meta.env.VITE_NODE_ENV === 'production';
const isDevelopment = import.meta.env.DEV || import.meta.env.VITE_NODE_ENV === 'development';

// API URL with smart fallbacks
const getApiUrl = () => {
  if (import.meta.env.VITE_API_BASE_URL) return import.meta.env.VITE_API_BASE_URL;
  if (import.meta.env.VITE_API_URL) return import.meta.env.VITE_API_URL;
  return isProduction ? PROD_API_URL : DEV_API_URL;
};

const getBackendUrl = () => {
  if (import.meta.env.VITE_BACKEND_URL) return import.meta.env.VITE_BACKEND_URL;
  return isProduction ? PROD_BACKEND_URL : DEV_BACKEND_URL;
};

// WebSocket URL construction
const getWebSocketUrl = () => {
  const backendUrl = getBackendUrl();
  // Convert http(s) to ws(s)
  const wsProtocol = backendUrl.startsWith('https') ? 'wss' : 'ws';
  const wsHost = backendUrl.replace(/^https?:\/\//, '');
  return `${wsProtocol}://${wsHost}`;
};

export const config = {
  apiBaseUrl: getApiUrl(),
  apiUrl: getApiUrl(), // Alias for consistency
  backendUrl: getBackendUrl(),
  webSocketUrl: getWebSocketUrl(),
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
  nodeEnv: import.meta.env.VITE_NODE_ENV || (isProduction ? 'production' : 'development'),
  maxFileSize: import.meta.env.VITE_MAX_FILE_SIZE,
  isDevelopment,
  isProduction,
};

// Log config in development for debugging
if (isDevelopment) {
  console.log('[Config] API URL:', config.apiBaseUrl);
  console.log('[Config] Backend URL:', config.backendUrl);
}

// Validation - warn but don't throw in production (use fallbacks instead)
const requiredEnvVars = [
  'VITE_API_BASE_URL',
];

const missingEnvVars = requiredEnvVars.filter(
  envVar => !import.meta.env[envVar]
);

if (missingEnvVars.length > 0) {
  if (isDevelopment) {
    console.warn(
      `[Config] Missing environment variables: ${missingEnvVars.join(', ')}. Using fallback URLs.`
    );
  }
  // In production, fallbacks are used automatically
}